// extracted by mini-css-extract-plugin
var _1 = "ColumnSelectPopup_selectDefaultButton__osniU";
export { _1 as "selectDefaultButton" }
